import CloseIcon from "@material-ui/icons/Close";
import SendIcon from "@material-ui/icons/Send";
import React, { Component } from "react";
import swal from "sweetalert";
import { fetchMethod } from "../../../FetchMethod";
import photo from "../../assets/photo.png";
import EditCompany from "../../LinkedinForm/EditCompany";
import EditPosition from "../../LinkedinForm/EditPosition";
import EditName from "../../LinkedinForm/EditName";
import EditSurname from "../../LinkedinForm/EditSurname";
import EditGender from "../../LinkedinForm/EditGender";
import EditCountry from "../../LinkedinForm/EditCountry";
import EditState from "../../LinkedinForm/EditState";
import { getContactImageUrl } from "../../../config";
import { getContactImageUrl2 } from "../../../config";

import {
 // CampaignsSteps2,
  getCampaignsSteps,
  UpdatePositionContact,
  UpdatefNameContact,
  SendMessages,
  UpdateCompanyContact,
  UpdateSurnameContact,
  UpdateGenderContact,
  UpdateCountryContact,
  UpdateStateContact
} from "../campaignQueries";
import "./ContactDetails.css";
import ContactDetailsAction from "./ContactDetailsAction";
class ContactDetails extends Component {


  constructor() {
    super();
    this.state = {
      id: null,
      messageText: null,
      setOpen: false,
      fName: "",
      validationAlert: ""
    };
  }
  componentDidMount() {

    this.campaignSteps();
  }

  campaignSteps = async () => {
    let data = await getCampaignsSteps(this.props.Campaignid);
  };

  formatDate = date => {
    if (date !== null && date !== undefined) {
      var date = new Date(date);
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      return (date = dd + "/" + mm + "/" + yyyy);
    }
  };
  formatDate1 = date => {
    if (date !== null && date !== undefined) {
      var date = new Date(date);
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;

      return (date = time);
    }
  };

  RecieveddateFomate = date => {
    if (date !== null && date !== undefined) {
      var date = new Date(date);
      let time1 = date.getTime();
      let time2 = date.getTimezoneOffset() * 60000;
      date = time1 + time2;
      date = new Date(date);

      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();

      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

      let time = hours + ":" + minutes + " " + am_pm;

      return (date = time);
    }
  };
  ConnectedOnformatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };
  handleSubmit = event => {
    event.preventDefault();
    this.SendMessage();
  };
  OnSubmit = event => {
    return event.key === "Enter" ? this.SendMessage() : "";
  };
  SendMessage = () => {
    var firstConn = this.props.details.connectedon;
    if (firstConn == null || firstConn == "") {
      swal(
        "This contact is not connected. Please send the message with Linkedin",
        { icon: "warning" }
      );
    } else {
      let test =
        this.state.messageText.trim().length > 0
          ? {
            data: {
              type: "SENT",
              campaignid: this.props.details.campaignid,
              contactid: this.props.details.id,
              message: this.state.messageText,
              realmsgdatetime: Date.now(),
              messagetobesent: 1
            }
          }
          : "";

      fetchMethod(SendMessages, test)
        .then(response => {
          return response.json();
        })
        .then(res => {
          this.setState({ messageText: "" }, () => {
            this.props.refreshMessage(this.props.details.id);
          });

          if (res.data.ContactmessagesCreate.id) {
          }
        })
        .catch(e => console.log(e));
    }
  };
 

  handleChange = event => {
    this.setState({ messageText: event.target.value });
  };

  OnSubmit = event => {
    return event.key === "Enter" ? this.SendMessage() : "";
  };
  handleOpen = () => {
    this.setState({ setOpen: true }, () => { });
  };
  handleClose = () => {
    this.setState({ setOpen: false });
  };

  render() {

    let details = this.props.details;

    let fName = details !== undefined ? details.fname : "";
    // let organization = details !== undefined ? details.organization : "";
    // let designation = details !== undefined ? details.designation : "";
    // let customer = this.props.Customer;
    let workflowStep = this.props.ContactDetailsWorkflow;

    let ContactDetailsMessages = this.props.ContactDetailsMessages;

    let Name = details !== undefined ? details.name : "";
    let surname = details !== undefined ? details.surname : "";
    let gender = details !== undefined ? details.gender : "";

    let image =
      details !== undefined &&
        details.profileimage !== undefined &&
        details.profileimage !== null
        ? details.profileimage.substr(0, 5)
        : "";


    return (
      <div className="DetailsContact">
        <div className="Details">
          <div className="Close">
            <h2 style={{ color: "#346beb" }}>{this.props.heading}</h2>
            <div>
              <CloseIcon
                onClick={this.props.Close}
                style={{ cursor: "pointer" }}
                fontSize="small"
              />
            </div>
          </div>
          <div className="Photo">
            <div className="Image">
             
              {image === "https" ? (
                <img
                  src={details.profileimage}
                  onError={({ currentTarget }) => {
                 let imageSourceUrl=getContactImageUrl;    
                   if (details.id > 917500){
                   imageSourceUrl =getContactImageUrl2;
                   }
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = imageSourceUrl.url + details.image;
                  }}
                  style={{
                    width: "88px",
                    height: "88px",
                    border: "1px",
                    borderColor: "gray"
                  }}
                />
              ) : (
                <img
                  src={photo}
                  style={{
                    width: "88px",
                    height: "88px",
                    border: "single",
                    borderColor: "gray"
                  }}
                />
              )}
            </div>
            <div>
              <h2 style={{ color: "#346beb" }}>{Name}</h2>

              <div className="Headline">
                <ul>
                  <li className=" FirstName">
                    <span>Gender </span>
                    <span>:</span>
                    <span>{details !== undefined ? gender : ""}</span>
                    <span className="EditIcon">
                      <EditGender
                        editableData={this.props.details}
                        query={UpdateGenderContact}
                        updateData={() => {
                          this.props.onSearchClick();

                          this.props.refreshMessage(this.props.details.id);
                        }}
                        className={"editGender"}
                      />
                    </span>
                  </li>

                  <li className=" FirstName">
                    <span>First Name</span>
                    <span>:</span>
                    <span>{details !== undefined ? fName : ""}</span>
                    <span className="EditIcon">
                      <EditName
                        editableData={this.props.details}
                        query={UpdatefNameContact}
                        updateData={() => {
                          this.props.onSearchClick();

                          this.props.refreshMessage(this.props.details.id);
                        }}
                        className={"editFName"}
                      />
                    </span>
                  </li>

                  <li className=" FirstName">
                    <span>Surname </span>
                    <span>:</span>
                    <span>{details !== undefined ? surname : ""}</span>
                    <span className="EditIcon">
                      <EditSurname
                        editableData={this.props.details}
                        query={UpdateSurnameContact}
                        updateData={() => {
                          this.props.onSearchClick();
                          this.props.refreshMessage(this.props.details.id);
                        }}
                        className={"EditSurname"}
                      />
                    </span>
                  </li>                

                  <li>
                    <span>Phone</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.phonenumber : ""}
                    </span>
                  </li>

                  <li>
                    <span>Email</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.email : ""}</span>
                  </li>

                  <li>
                    <span>D.O.B</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.dateofbirth : ""}
                    </span>
                  </li>

                  <li>
                    <span>Connected On</span>
                    <span>:</span>
                    <span>
                      {details !== undefined
                        ? this.ConnectedOnformatDate(details.connectedon)
                        : ""}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="Action">
              {localStorage.getItem("role") !== "CUSTOMER" ? (
                <ContactDetailsAction
                  contactStatus={this.props.contactStatus}
                  Close={this.props.Close}
                  campaignStatus={this.props.campaignStatus}
                  Campaignid={this.state.getCampaignId}
                  id={this.props.id}
                  tableRerender={this.props.tableRerender}
                  limit={this.props.limit}
                  offset={this.props.offset}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="ContactSection">
            <div className="ContactAddress">
              <p>Address</p>
              <div className="">
                <ul>
                  <li>
                    <span>Location</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.location : ""}</span>
                  </li>
                  <li>
                    <span>State</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.state : ""}
                      <span className="EditIcon">
                        <EditState
                          editableData={this.props.details}
                          query={UpdateStateContact}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"EditState"}
                        />
                      </span>
                    </span>
                  </li>
                  <li>
                    <span>Country</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.country : ""}
                      <span className="EditIcon">
                        <EditCountry
                          editableData={this.props.details}
                          query={UpdateCountryContact}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"EditCountry"}
                        />
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="SocialContacts">
              <p>Social Contacts</p>
              <div className="">
                <ul>
                  <li>
                    <span>Twitter</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.twitter : ""}</span>
                  </li>

                  <li>
                    <span>Skype</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.skype : ""}</span>
                  </li>

                  <li>
                    <span>Followers</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.numberoffollowers : ""}
                    </span>
                  </li>

                  <li>
                    <span>LinkedIn</span>
                    <span>:</span>
                    <span>
                      <a
                        href={details !== undefined ? details.linkedinid : ""}
                        title={details !== undefined ? details.linkedinid : ""}
                        target="_blank"
                      >
                        {details !== undefined ? details.linkedinid : ""}
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ProfessionalDetails">
              <p>Professional Details</p>
              <div className="">
                <ul>
                  <li>
                    <span>Current Position</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.designation : ""}
                      <span className="EditIcon">
                        <EditPosition
                          editableData={this.props.details}
                          query={UpdatePositionContact}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"EditPosition"}
                        />
                      </span>
                    </span>
                  </li>

                  <li>
                    <span>Company</span>
                    <span>:</span>
                    <span>
                      {details !== undefined ? details.organization : ""}
                      <span className="EditIcon">
                        <EditCompany
                          editableData={this.props.details}
                          query={UpdateCompanyContact}
                          updateData={() => {
                            this.props.onSearchClick();
                            this.props.refreshMessage(this.props.details.id);
                          }}
                          className={"editFName"}
                        />
                      </span>
                    </span>
                  </li>

                  <li>
                    <span>Industry</span>
                    <span>:</span>
                    <span>{details !== undefined ? details.industry : ""}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <h3>Workflow Followed </h3>

          {workflowStep !== undefined &&
            workflowStep !== null &&
            workflowStep.length !== 0 ? (
            workflowStep.map((workflow, index) => {
              var stepDate = workflow.utctasktime;

              if (workflow.utctasktime == null) {

                stepDate = workflow.executedon;
              }
              let count = index + 1;

              if (
                workflow.contactworkflowhistoryIbfk2rel.Campaignsteps.length ===
                1
              ) {
                return (
                  <div className="WorkflowFollow">
                    <span>
                      {workflow.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
                        .stepname === "VISIT"
                        ? "Visit"
                        : workflow.contactworkflowhistoryIbfk2rel
                          .Campaignsteps[0].stepname === "SEND_INVITE" &&
                          workflow.successflag == 1
                          ? "Invite Sent"
                          : workflow.contactworkflowhistoryIbfk2rel
                            .Campaignsteps[0].stepname === "SEND_INVITE" &&
                            workflow.successflag == 0
                            ? "Invite Not Sent"
                            : workflow.contactworkflowhistoryIbfk2rel
                              .Campaignsteps[0].stepname === "SEND_THANKS_MESSAGE"
                              ? "Send Thanks Message"
                              : workflow.contactworkflowhistoryIbfk2rel
                                .Campaignsteps[0].stepname === "FOLLOW"
                                ? "Follow"
                                : workflow.contactworkflowhistoryIbfk2rel
                                  .Campaignsteps[0].stepname === "SEND_EMAIL"
                                  ? "Send InMail"
                                  : "Send Message"}
                    </span>

                    <span>{this.formatDate(stepDate)}</span>
                    <span>{this.formatDate1(stepDate)}</span>
                    <span className="stepincrease">Step{" " + count}</span>
                  </div>
                );
              }
            })
          ) : (
            <div className="NoWorkflow">No workflow Followed</div>
          )}

          <div className="ContactDetailsMessages">
            <h3> Messages</h3>
            {ContactDetailsMessages !== undefined &&
              ContactDetailsMessages !== null &&
              ContactDetailsMessages.length !== 0
              ? ContactDetailsMessages.map(message => {
             
                var messageDate = message.utcmessagetime;

                if (message.utcmessagetime == null) {

                  messageDate = message.messagedatetime;
                }



                if (
                  message.type === "SENT" &&
                  message.message !== "" &&
                  message.message !== null
                ) {

                  return (
                    <React.Fragment>
                      <div className="SentMessages">
                        <span>{message.message}</span>
                      </div>
                      <div className="SentMessageData">

                        <span>
                          {messageDate
                            ? this.formatDate(messageDate)
                            : ""}
                        </span>
                        <span>
                          {this.formatDate1(messageDate)}

                        </span>
                      </div>
                    </React.Fragment>
                  );
                } else if (
                  message.message !== "" &&
                  message.message !== null
                ) {
                  return (
                    <React.Fragment>
                      <div className="ReceivedMessages">
                        <span>{message.message}</span>
                      </div>
                      <div className="ReceivedMessageData">
                
                        <span>
                          {messageDate
                            ? this.formatDate(messageDate)
                            : ""}
                        </span>
                        <span>
                          {this.formatDate1(messageDate)}
                        </span>
                      </div>
                    </React.Fragment>
                  );
                }
              })
              : ""}
          </div>

          <div className="chatInputWrapper">
            <div>
              <textarea
                className="textareaInput"
                type="text"
                value={this.state.messageText}
                placeholder="Type your message here..."
                onChange={this.handleChange}
              />
            </div>
            <div>
              <SendIcon className="sendIcon" onClick={this.handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactDetails;
